var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"quick-title",rawName:"v-quick-title",value:(_vm.message),expression:"message"}],staticClass:"beta-tag",style:(_vm.elStyle),on:{"click":_vm.alertMessage}},[_vm._v(" "+_vm._s(_vm.$t('message.BETA_TAG'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }